import type { SchemaBuilderExpressionProps } from "./schema-builder-expression.type";

import { SchemaBuilderExpressionFormula } from "./schema-builder-expression-formula";
import { SchemaBuilderExpressionVariables } from "./schema-builder-expression-variables";

import "./schema-builder-expression.style.less";

export const SchemaBuilderExpression = (
  fieldProps: SchemaBuilderExpressionProps
) => {
  const { name } = fieldProps;

  return (
    <div className="schema-builder-expression">
      <SchemaBuilderExpressionFormula {...fieldProps} />
      <SchemaBuilderExpressionVariables name={name} />
    </div>
  );
};
